import { render } from "./App.vue?vue&type=template&id=eaf1de5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=eaf1de5a&lang=css"
script.render = render

export default script